function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M47.313,61.702c-.313,0-.627-.075-.908-.216l-6.446-3.223-6.358,3.221c-.285.143-.6.217-.914.217-1.134,0-2.057-.921-2.057-2.052,0-.783.435-1.486,1.135-1.835l6.183-3.09v-9.712c0-1.131.921-2.052,2.052-2.052s2.052.92,2.052,2.052v9.71l6.184,3.092c.489.244.855.665,1.028,1.186.174.52.135,1.077-.109,1.566-.35.701-1.054,1.136-1.836,1.136h-.006Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M40.03,17.248c-4.755,0-8.624-3.869-8.624-8.624S35.275,0,40.03,0s8.624,3.869,8.624,8.624-3.869,8.624-8.624,8.624ZM40.03,3.782c-2.67,0-4.842,2.172-4.842,4.842s2.172,4.842,4.842,4.842,4.842-2.172,4.842-4.842-2.172-4.842-4.842-4.842Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M31.266,39.348c-3.518,0-6.38-2.862-6.38-6.38v-2.244c0-5.993,4.876-10.868,10.869-10.868h8.49c5.993,0,10.869,4.875,10.869,10.868v2.244c0,3.518-2.862,6.38-6.38,6.38h-17.468ZM35.755,23.638c-3.907,0-7.086,3.179-7.086,7.086v2.244c0,1.432,1.165,2.598,2.597,2.598h17.468c1.432,0,2.597-1.165,2.597-2.598v-2.244c0-3.907-3.179-7.086-7.086-7.086h-8.49Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M16.497,57.9c-4.755,0-8.624-3.869-8.624-8.624s3.869-8.624,8.624-8.624,8.624,3.869,8.624,8.624-3.869,8.624-8.624,8.624ZM16.497,44.434c-2.67,0-4.842,2.172-4.842,4.842s2.172,4.842,4.842,4.842,4.842-2.172,4.842-4.842-2.172-4.842-4.842-4.842Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M7.732,80c-3.518,0-6.38-2.862-6.38-6.38v-2.244c0-5.993,4.876-10.868,10.869-10.868h8.49c5.993,0,10.869,4.875,10.869,10.868v2.244c0,3.518-2.862,6.38-6.38,6.38H7.732ZM12.221,64.29c-3.907,0-7.086,3.179-7.086,7.086v2.244c0,1.432,1.165,2.598,2.597,2.598h17.468c1.432,0,2.597-1.165,2.597-2.598v-2.244c0-3.907-3.179-7.086-7.086-7.086h-8.49Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M63.564,57.9c-4.755,0-8.624-3.869-8.624-8.624s3.869-8.624,8.624-8.624,8.624,3.869,8.624,8.624-3.869,8.624-8.624,8.624ZM63.564,44.434c-2.67,0-4.842,2.172-4.842,4.842s2.172,4.842,4.842,4.842,4.842-2.172,4.842-4.842-2.172-4.842-4.842-4.842Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M54.8,80c-3.518,0-6.38-2.862-6.38-6.38v-2.244c0-5.993,4.876-10.868,10.869-10.868h8.49c5.993,0,10.869,4.875,10.869,10.868v2.244c0,3.518-2.862,6.38-6.38,6.38h-17.468ZM59.289,64.29c-3.907,0-7.086,3.179-7.086,7.086v2.244c0,1.432,1.165,2.598,2.597,2.598h17.468c1.432,0,2.597-1.165,2.597-2.598v-2.244c0-3.907-3.179-7.086-7.086-7.086h-8.49Z"
});

var SvgNavGroup = function SvgNavGroup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_group.c5eec692.svg";
export { ForwardRef as ReactComponent };